import { logger } from "../utils/logger";

export const SUPABASE_URL = import.meta.env.VITE_API_URL as string;
export const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_API_KEY as string;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  logger.warn(
    "Supabase credentials missing. Ensure VITE_API_URL and VITE_SUPABASE_API_KEY are set in .env"
  );
}
